import { useTranslation } from "react-i18next";
import type { ReportAsset } from "@/api/report";

export function AssetCard({
  asset,
  onInsert,
  onDelete,
  busy,
  labelReq,
  onLabelReq,
}: {
  asset: ReportAsset;
  onInsert: () => void;
  onDelete: () => void;
  busy: boolean;
  /** "Request a label-the-diagram question on this figure" state, when supported. */
  labelReq?: { on: boolean; instruction: string };
  onLabelReq?: (next: { on: boolean; instruction: string }) => void;
}) {
  const { t } = useTranslation();
  return (
    <figure className="m-0 rounded-lg border border-black/10 p-2">
      {asset.url ? (
        <img
          src={asset.url}
          alt={asset.caption ?? asset.filename}
          loading="lazy"
          className="h-28 w-full rounded object-contain"
        />
      ) : (
        <div className="flex h-28 items-center justify-center rounded bg-zinc-100 text-xs text-ink-faint">
          {t("no preview")}
        </div>
      )}
      <figcaption className="mt-1 truncate text-[11px] text-ink-faint" title={asset.caption ?? asset.filename}>
        {asset.caption || asset.filename}
      </figcaption>
      <div className="mt-1 flex items-center justify-between">
        <span className="rounded-full bg-zinc-100 px-1.5 py-0.5 text-[10px] text-zinc-500">{asset.origin}</span>
        <div className="flex gap-2">
          <button
            type="button"
            disabled={busy}
            onClick={onInsert}
            className="text-[11px] font-medium text-brand-600 hover:underline"
          >
            {t("Insert")}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onDelete}
            className="text-[11px] font-medium text-rose-600 hover:underline"
          >
            {t("Delete")}
          </button>
        </div>
      </div>
      {onLabelReq && (
        <div className="mt-1 border-t border-black/5 pt-1">
          <button
            type="button"
            onClick={() => onLabelReq({ on: !labelReq?.on, instruction: labelReq?.instruction ?? "" })}
            className={`text-[11px] font-medium hover:underline ${labelReq?.on ? "text-emerald-600" : "text-ink-faint"}`}
          >
            {labelReq?.on ? t("✓ Label question requested") : t("Request label question")}
          </button>
          {labelReq?.on && (
            <textarea
              value={labelReq.instruction}
              onChange={(e) => onLabelReq({ on: true, instruction: e.target.value.slice(0, 500) })}
              rows={2}
              placeholder={t("Instructions (optional) — e.g. “blank only the axis labels”")}
              className="mt-1 w-full rounded border border-black/10 px-2 py-1 text-[11px]"
            />
          )}
        </div>
      )}
    </figure>
  );
}
